<div [formGroup]="formGroupInstance">
  <input matInput [matAutocomplete]="autoComplete" formControlName="{{ controlModel.formKey }}" class="mt-10" />
  <mat-autocomplete #autoComplete="matAutocomplete" [displayWith]="displayFn">
    <mat-option *ngFor="let item of list" [value]="item.value" (click)="handleOptionSelection(item)">
      {{ item.name }}
    </mat-option>
  </mat-autocomplete>
</div>